__turbopack_context__.v({
  "answer": "PricingFAQ-module__IKFZ8G__answer",
  "container": "PricingFAQ-module__IKFZ8G__container",
  "expanded": "PricingFAQ-module__IKFZ8G__expanded",
  "faqContent": "PricingFAQ-module__IKFZ8G__faqContent",
  "faqHeader": "PricingFAQ-module__IKFZ8G__faqHeader",
  "faqItem": "PricingFAQ-module__IKFZ8G__faqItem",
  "faqList": "PricingFAQ-module__IKFZ8G__faqList",
  "icon": "PricingFAQ-module__IKFZ8G__icon",
  "section": "PricingFAQ-module__IKFZ8G__section",
  "subtitle": "PricingFAQ-module__IKFZ8G__subtitle",
  "title": "PricingFAQ-module__IKFZ8G__title",
});
